module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kL0c0"))).then(() => parcelRequire('2KbAe'));